import React from 'react';

/* ═══════════════════════════════════════════════════════════════════════════
   HUNTER — EYLÜL 2026 MEDYA PLANI                                  ₺75.000
   ---------------------------------------------------------------------------
   Fatmagül Hanım'ın 2 Eylül tarihli mailine yanıt. Talebi: "Eylül ayı için
   kampanya yapısı ve bütçe dağılımı önerilerinizi almak isteriz."

   Hupalupa/KIXX Eylül planlarıyla aynı desen: birim maliyetlerin tamamı
   AĞUSTOS 2026'da hesapta GERÇEKLEŞEN veriden geliyor (3 Eylül'de çekildi),
   hesapta karşılığı olmayan satırlar `kaynak: 'benchmark'` diye işaretli.

   🔑 Bu planın diğerlerinden farkı: bütçe dağılımından ÖNCE bir ölçüm sorunu
      var. Meta'da 8 ayda ₺402.595 harcandı, kayıtlı satış SIFIR. Sayfa bu
      bulguyla açılıyor, çünkü Meta bütçesinin karşılığı bugün ölçülemiyor.

   🔑 Sayıların tamamı aşağıdaki PLAN dizisinden TÜRETİLİYOR. Tabloya elle
      yazılmış tek bir toplam yok; `butce` alanını değiştir, hepsi güncellenir.
   ═══════════════════════════════════════════════════════════════════════════ */

/* ── Kampanya amacı rozeti (Hupalupa/KIXX planlarıyla aynı renk kodu) ────── */
const AMAC_STIL = {
  'Dönüşüm': 'bg-emerald-50 text-emerald-700 border-emerald-200',
  'Farkındalık': 'bg-red-50 text-red-700 border-red-200',
  'Etkileşim': 'bg-pink-50 text-pink-700 border-pink-200',
};

function Amac({ tip }) {
  return (
    <span className={`inline-flex items-center px-2 py-0.5 rounded-md border text-[11px] font-medium whitespace-nowrap ${AMAC_STIL[tip] || 'bg-gray-50 text-gray-700 border-gray-200'}`}>
      {tip}
    </span>
  );
}

/* ── Mecra kimlikleri ────────────────────────────────────────────────────── */
const MECRA = {
  google: { ad: 'Google Ads', logo: '/google_ads-512.webp' },
  meta: { ad: 'Meta Ads', logo: '/6033716.png' },
};

/* ── PLAN ────────────────────────────────────────────────────────────────────
   `cpc` / `cpm` / `cpv` çıktının kaynağı ve hepsi SEZON İÇİ tahmindir.

   🔑 Ağustos ölü sezonun dibidir; oradaki birim maliyetleri Eylül'e taşımak
      tıklama tahminini şişirir. Arama hacmi Ağustos→Eylül 3,75 katına
      çıkarken ihale fiyatı sabit kalmaz. Bu yüzden `taban` alanı gerçekleşen
      değeri tutar, `cpc` ise sezon seviyesine çekilmiş halidir.
      Çıpa: Keyword Planner'ın tepe sayfa teklifleri (yağmur çizmesi ₺10,95 ·
      yağmur botu ₺14,09 · hunter çizme ₺9,59 · ganni ₺53,20) — sezon içi
      gerçekleşen CPC bunların altında kalır ama Ağustos'un çok üstündedir.
      `kaynak: 'sezon'` = gerçekleşenden düzeltilmiş, `'benchmark'` = hesapta
      karşılığı yok. `donem` satırın ay içinde hangi aşamada açıldığıdır.
   ------------------------------------------------------------------------- */
const PLAN = [
  /* ─────────────── GOOGLE ADS ₺42.000 ─────────────── */
  {
    mecra: 'google', kampanya: 'Search — Marka (exact)', amac: 'Dönüşüm', butce: 7000,
    kitle: '"hunter", "hunter boots", "hunter türkiye" arayanlar',
    cpc: 9.00, cpm: 1850, taban: 7.95, tabanAd: 'Ağu gerçekleşen', kaynak: 'sezon', donem: 'ay boyu',
    gerekce: 'Ağustos’ta ₺18.239 harcadı, kısıyoruz: "hunter" sorgusunda organik sıralamamız zaten 1,2. Bütçe 14 Eylül lansmanındaki marka arama sıçramasını karşılayacak kadar tutuldu.',
  },
  {
    mecra: 'google', kampanya: 'Search — Marka (phrase)', amac: 'Dönüşüm', butce: 5000,
    kitle: 'Marka + ürün/kategori birleşimleri ("hunter çizme", "hunter çocuk bot")',
    cpc: 5.00, cpm: 1400, taban: 2.65, tabanAd: 'Ağu gerçekleşen', kaynak: 'sezon', donem: 'ay boyu',
    gerekce: 'Aynı marka trafiğini exact kampanyanın üçte biri maliyetle alıyor (₺2,65 / ₺7,95 CPC). Bütçe kaydırması bilinçli.',
  },
  {
    mecra: 'google', kampanya: 'Search — Markasız (yağmur çizmesi kümesi)', amac: 'Dönüşüm', butce: 10000,
    kitle: '"yağmur çizmesi", "yağmur botu", "çocuk yağmur çizmesi" · kadın/erkek/çocuk ayrı grup',
    cpc: 7.50, cpm: 1100, taban: 3.06, tabanAd: 'Oca–May gerçekleşen', kaynak: 'sezon', donem: '1 Eylül',
    gerekce: 'Mayıs’ta kapatılan Search — Generic yeniden açılıyor. ₺12.459 harcayıp ₺488.585 üretmişti; gösterim payının %72,3’ünü sıralamaya kaybediyordu, yani doymamıştı.',
  },
  {
    mecra: 'google', kampanya: 'Search — GANNI', amac: 'Dönüşüm', butce: 3000,
    kitle: '"hunter ganni", "ganni bot", "ganni çizme", "ganni türkiye"',
    cpc: 12.00, cpm: 1300, taban: null, tabanAd: 'KP tepe teklif ₺53,20', kaynak: 'benchmark', donem: '10 Eylül',
    gerekce: 'Düşük hacim, düşük maliyet, yüksek koruma. Lansmanda oluşacak GANNI aramalarının pazaryerlerine gitmesini engelliyor. Lansmandan 4 gün önce açılıyor ki öğrenmesini bitirsin.',
  },
  {
    mecra: 'google', kampanya: 'Performance Max — Tüm Ürünler', amac: 'Dönüşüm', butce: 13000,
    kitle: 'Geniş + alışveriş sinyalli · ürün grupları ciro payına göre bölünmüş',
    cpc: 8.00, cpm: 170, taban: 6.14, tabanAd: 'Ağu gerçekleşen', kaynak: 'sezon', donem: '1 Eylül',
    gerekce: 'Ağustos’ta ₺8.406 ile çalıştı, gösterim payının %75,3’ünü SIRALAMAYA kaybetti. Sebep bütçe değil envanter kalitesi: 840 varyantta beden eksik, item_group_id yok, site AdsBot-Google’a 403 dönüyor. Feed düzeltilmeden bütçe artırmak parayı aynı sıralama kaybına yatırmaktır.',
  },
  {
    mecra: 'google', kampanya: 'Demand Gen — GANNI kreatifi', amac: 'Farkındalık', butce: 4000,
    kitle: 'Moda ve outdoor ilgi alanları · Discover + YouTube akışı',
    cpc: 2.50, cpm: 75, taban: null, tabanAd: null, kaynak: 'benchmark', donem: '14 Eylül',
    gerekce: 'Aralık–Mayıs arasında ₺46.229 harcayıp 260.457 tık getirmişti — tık başı ₺0,18, yani niteliksiz. Yerleşim dışlama listesi ve marka güvenliği filtresiyle, YALNIZCA GANNI kreatifiyle yeniden açılıyor.',
  },

  /* ─────────────── META ADS ₺28.000 ─────────────── */
  {
    mecra: 'meta', kampanya: 'Advantage+ Katalog Satış', amac: 'Dönüşüm', butce: 13000,
    kitle: 'Geniş prospecting · katalog satın alma sinyali',
    cpc: 6.50, cpm: 260, taban: null, tabanAd: null, kaynak: 'benchmark', donem: '1 Eylül',
    gerekce: 'Meta bütçesinin sekiz ayda İLK KEZ satın alma optimizasyonuyla çalıştığı kalem. Birim maliyet benchmark, çünkü hesapta dönüşüm amaçlı tek bir kampanya geçmişi yok.',
  },
  {
    mecra: 'meta', kampanya: 'GANNI Lansmanı — erişim + video', amac: 'Farkındalık', butce: 8000,
    kitle: '18-40 moda ilgi alanları · Instagram etkileşimcileri · site ziyaretçisi lookalike',
    cpm: 55, cpv: 0.15, taban: 33.72, tabanAd: 'Ağu gerçekleşen CPM', kaynak: 'sezon', donem: '14–20 Eylül',
    gerekce: 'Ürün 20 Eylül’de geliyor. Bu kalem satış yapmıyor, 20 Eylül’de dönüştürülecek izinli kitleyi kuruyor. CPM Ağustos’un gerçekleşeni — aynı satın alma tipi.',
  },
  {
    mecra: 'meta', kampanya: 'Katalog Yeniden Pazarlama', amac: 'Dönüşüm', butce: 5000,
    kitle: 'Son 30 gün ürün gören / sepete ekleyen / satın almayan + ön kayıt listesi',
    cpc: 4.00, cpm: 230, taban: null, tabanAd: null, kaynak: 'benchmark', donem: '20 Eylül',
    gerekce: 'Kasım–Şubat için havuzun doldurulduğu yer. Ağustos’ta hiç yoktu — sekiz aydır biriken trafiğin tamamı yeniden pazarlanmadan kayboldu.',
  },
  {
    mecra: 'meta', kampanya: 'Kreatif Testi', amac: 'Etkileşim', butce: 2000,
    kitle: 'Geniş · haftada iki yeni format',
    cpc: 2.00, cpm: 52, taban: 1.29, tabanAd: 'Ağu gerçekleşen', kaynak: 'sezon', donem: 'ay boyu',
    gerekce: 'Ekim’de ölçeklenecek kreatifi Eylül’de bulmak için. Ağustos’un gerçekleşen CPM’i bu satırda geçerli, çünkü satın alma tipi aynı kalıyor.',
  },
];

/* Rezerv PLAN dışında: kampanyası yok, 20 Eylül'de dağıtılıyor. */
const REZERV = 5000;

/* ── Ağustos 2026 GERÇEKLEŞEN (3 Eylül'de hesaptan çekildi, tam ay) ─────────
   Google: 3 kampanya · Meta: 9 kampanya. Meta'nın dönüşüm ve ciro sütunu
   BOŞ DEĞİL, SIFIR — hesap sekiz aydır tek satış raporlamıyor.             */
const AGUSTOS = {
  google: { harcama: 35002, gosterim: 86788, tik: 6820, cpc: 5.13, cpm: 403.30, donusum: 82, ciro: 666877, roas: 19.05, kampanya: 3 },
  meta: { harcama: 38775, gosterim: 1149808, tik: 30043, cpc: 1.29, cpm: 33.72, donusum: 0, ciro: 0, roas: 0, kampanya: 9 },
};
const AGUSTOS_TOPLAM = { harcama: 73777, gosterim: 1236596, tik: 36863, cpc: 2.00, cpm: 59.66 };

/* GA4 — tek doğru ciro kaynağı. Google Ads'in raporladığı ₺666.877, sitenin
   TAMAMININ cirosunun 2,5 katı; atıf şişmesi var, aşağıda not edildi.      */
const GA4_AGUSTOS = { oturum: 6582, ciro: 263089, urun: 41 };
const GA4_SON30 = { oturum: 6595, ciro: 289493 };
const GA4_ONCEKI30 = { oturum: 3907, ciro: 191026 };

/* ── GA4 aylık ciro — mevsim eğrisinin kaynağı ──────────────────────────── */
const CIRO_SERI = [
  { y: 2025, a: 9, v: 6700 }, { y: 2025, a: 10, v: 118388 }, { y: 2025, a: 11, v: 998284 },
  { y: 2025, a: 12, v: 1179110 }, { y: 2026, a: 1, v: 1608302 }, { y: 2026, a: 2, v: 2170688 },
  { y: 2026, a: 3, v: 1072039 }, { y: 2026, a: 4, v: 429801 }, { y: 2026, a: 5, v: 211349 },
  { y: 2026, a: 6, v: 112019 }, { y: 2026, a: 7, v: 189902 }, { y: 2026, a: 8, v: 263089 },
];
const HEDEF_EYLUL = 525000;
const AY_KISA = { 1: 'Oca', 2: 'Şub', 3: 'Mar', 4: 'Nis', 5: 'May', 6: 'Haz', 7: 'Tem', 8: 'Ağu', 9: 'Eyl', 10: 'Eki', 11: 'Kas', 12: 'Ara' };

/* ── ARAMA HACMİ — Google Keyword Planner, Türkiye + Türkçe, GOOGLE_SEARCH ──
   3 Eylül 2026'da çekildi. Keyword Planner serisi ~1-2 ay gecikmeli biter,
   son veri Temmuz 2026.

   🔑 Çıplak "hunter" tabloda VAR ama `karisik: true` ile işaretli: 12.100/ay
      hacmin önemli kısmı marka değil (Hunter x Hunter animesi, avcılık).
      Kanıt: Search Console'da "hunter" sorgusunda ortalama sıramız 1,2 ama
      CTR yalnızca %5,5 — birinci sıradayken kimse tıklamıyorsa arayan kişi
      bizi aramıyordur. Grafikteki sezon kümesine bu yüzden GİRMİYOR (kümeyi
      şişirir); tabloda duruyor çünkü ihalede karşımıza çıkan hacim bu.
   ------------------------------------------------------------------------- */
const ARAMA_KELIMELER = [
  { kw: 'hunter', tip: 'marka', ag25: 12100, ey25: 14800, ek25: 22200, son: 12100, rekabet: 'LOW', teklif: 57.66, karisik: true },
  { kw: 'hunter çizme', tip: 'marka', ag25: 2400, ey25: 8100, ek25: 33100, son: 1900, rekabet: 'HIGH', teklif: 9.59 },
  { kw: 'hunter bot', tip: 'marka', ag25: 1000, ey25: 2400, ek25: 5400, son: 720, rekabet: 'HIGH', teklif: 10.87 },
  { kw: 'hunter boots', tip: 'marka', ag25: 880, ey25: 1600, ek25: 1900, son: 480, rekabet: 'HIGH', teklif: 51.99 },
  { kw: 'yağmur çizmesi', tip: 'markasız', ag25: 1900, ey25: 8100, ek25: 18100, son: 880, rekabet: 'HIGH', teklif: 10.95 },
  { kw: 'yağmur botu', tip: 'markasız', ag25: 1000, ey25: 6600, ek25: 12100, son: 480, rekabet: 'HIGH', teklif: 14.09 },
  { kw: 'çocuk yağmur çizmesi', tip: 'markasız', ag25: 880, ey25: 4400, ek25: 8100, son: 260, rekabet: 'HIGH', teklif: 11.63 },
  { kw: 'ganni', tip: 'GANNI', ag25: 4400, ey25: 5400, ek25: 5400, son: 3600, rekabet: 'MEDIUM', teklif: 53.20 },
];

/* Sezon kümesi = beş çekirdek kelime (çıplak "hunter", "hunter boots" ve
   "ganni" hariç). Grafiğin kaynağı bu toplam.                              */
const ARAMA_SERI = [
  { y: 2022, a: 8, v: 14300 }, { y: 2022, a: 9, v: 44600 }, { y: 2022, a: 10, v: 46300 }, { y: 2022, a: 11, v: 45800 },
  { y: 2022, a: 12, v: 37800 }, { y: 2023, a: 1, v: 20400 }, { y: 2023, a: 2, v: 12580 }, { y: 2023, a: 3, v: 12380 },
  { y: 2023, a: 4, v: 9690 }, { y: 2023, a: 5, v: 6790 }, { y: 2023, a: 6, v: 4970 }, { y: 2023, a: 7, v: 4100 },
  { y: 2023, a: 8, v: 7820 }, { y: 2023, a: 9, v: 28300 }, { y: 2023, a: 10, v: 48400 }, { y: 2023, a: 11, v: 75000 },
  { y: 2023, a: 12, v: 42300 }, { y: 2024, a: 1, v: 23900 }, { y: 2024, a: 2, v: 8500 }, { y: 2024, a: 3, v: 7070 },
  { y: 2024, a: 4, v: 3700 }, { y: 2024, a: 5, v: 4120 }, { y: 2024, a: 6, v: 2100 }, { y: 2024, a: 7, v: 3540 },
  { y: 2024, a: 8, v: 7990 }, { y: 2024, a: 9, v: 33800 }, { y: 2024, a: 10, v: 30100 }, { y: 2024, a: 11, v: 38300 },
  { y: 2024, a: 12, v: 35600 }, { y: 2025, a: 1, v: 14700 }, { y: 2025, a: 2, v: 12000 }, { y: 2025, a: 3, v: 4720 },
  { y: 2025, a: 4, v: 5070 }, { y: 2025, a: 5, v: 3170 }, { y: 2025, a: 6, v: 2000 }, { y: 2025, a: 7, v: 2730 },
  { y: 2025, a: 8, v: 7180 }, { y: 2025, a: 9, v: 29600 }, { y: 2025, a: 10, v: 76800 }, { y: 2025, a: 11, v: 51400 },
  { y: 2025, a: 12, v: 48400 }, { y: 2026, a: 1, v: 39100 }, { y: 2026, a: 2, v: 31600 }, { y: 2026, a: 3, v: 16220 },
  { y: 2026, a: 4, v: 10190 }, { y: 2026, a: 5, v: 6580 }, { y: 2026, a: 6, v: 2810 }, { y: 2026, a: 7, v: 4240 },
];

/* ── DÖRT AĞUSTOS — sezon kümesinin Ağu→Eyl→Eki seyri, 2022'den beri ───────
   🔑 Sayfanın en sağlam iddiası burada: Ağustos→Eylül çarpanı dört yıldır
      3,1–4,2 bandında. Tek yılın tesadüfü değil, tekrar eden bir desen.
      Ağustos→Ekim çarpanı ise oynak (3,2×–10,7×) çünkü Ekim zirvesi yağmurun
      ne zaman başladığına bağlı. Bu yüzden taahhüt Eylül çarpanına verilir,
      Ekim'e verilmez.                                                      */
const DORT_AGUSTOS = [
  { yil: 2022, agu: 14300, eyl: 44600, eki: 46300 },
  { yil: 2023, agu: 7820, eyl: 28300, eki: 48400 },
  { yil: 2024, agu: 7990, eyl: 33800, eki: 30100 },
  { yil: 2025, agu: 7180, eyl: 29600, eki: 76800 },
];
/* Temmuz→Ağustos çarpanı da istikrarlı (1,9×–2,6×). Ağustos 2026 Keyword
   Planner'da henüz yok (seri ~1-2 ay gecikmeli); Temmuz 2026'nın 4.240'ından
   türetilen tahmin aşağıda ve TAHMİN olduğu her yerde yazılı.              */
const TEMMUZ_AGUSTOS = [
  { yil: 2023, tem: 4100, agu: 7820 },
  { yil: 2024, tem: 3540, agu: 7990 },
  { yil: 2025, tem: 2730, agu: 7180 },
];
const TEMMUZ_2026 = 4240;

/* Marka mı kategori mi büyüyor? Aynı ayın (Temmuz) dört yılı.              */
const TEMMUZ_KARSILASTIRMA = [
  { kw: 'hunter çizme', tip: 'marka', y23: 880, y24: 720, y25: 880, y26: 1900 },
  { kw: 'hunter bot', tip: 'marka', y23: 260, y24: 320, y25: 390, y26: 720 },
  { kw: 'yağmur çizmesi', tip: 'markasız', y23: 1600, y24: 1300, y25: 720, y26: 880 },
  { kw: 'yağmur botu', tip: 'markasız', y23: 880, y24: 720, y25: 480, y26: 480 },
  { kw: 'çocuk yağmur çizmesi', tip: 'markasız', y23: 480, y24: 480, y25: 260, y26: 260 },
];


/* "hunter" marka talebi yıllık büyüme — aynı ayın iki yılı (Keyword Planner) */
const MARKA_BUYUME = [
  { ay: 'Eylül', y24: 9900, y25: 14800 },
  { ay: 'Ekim', y24: 9900, y25: 22200 },
  { ay: 'Kasım', y24: 12100, y25: 22200 },
  { ay: 'Aralık', y24: 12100, y25: 22200 },
];

/* ── Markasız organik talep — Search Console, son 90 gün (ÖLÜ SEZON) ──────
   Marka içeren sorgular bilerek dışarıda: buradaki iddia markasız talebin
   ölü sezonda bile karşılıksız durduğu.                                    */
const MARKASIZ_TALEP = [
  { q: 'yağmur çizmesi', tik: 135, gos: 2411, poz: 6.9 },
  { q: 'yağmur çizmesi kadın', tik: 56, gos: 945, poz: 6.0 },
  { q: 'çocuk yağmur çizmesi', tik: 20, gos: 834, poz: 5.7 },
  { q: 'çocuk yağmur botu', tik: 29, gos: 625, poz: 3.8 },
  { q: 'yağmur botu', tik: 6, gos: 612, poz: 8.5 },
  { q: 'kadın yağmur çizmesi', tik: 21, gos: 571, poz: 5.6 },
  { q: 'yağmur çizmesi çocuk', tik: 19, gos: 552, poz: 4.8 },
  { q: 'yağmur botu çocuk', tik: 8, gos: 472, poz: 5.4 },
  { q: 'yağmur botu kadın', tik: 17, gos: 456, poz: 6.1 },
  { q: 'kadın yağmur botu', tik: 11, gos: 388, poz: 5.7 },
];

/* ── Kategori kırılımı — GA4, son 90 gün. Fatmagül'ün FTW/ACC/App diline
   çevrilebilmesi için `grup` alanı var.                                    */
const KATEGORI = [
  { ad: 'Kadın', grup: 'FTW', ciro: 311844, adet: 44, gor: 9196 },
  { ad: 'Erkek', grup: 'FTW', ciro: 143985, adet: 20, gor: 5258 },
  { ad: 'Çocuk', grup: 'FTW', ciro: 51894, adet: 26, gor: 2312 },
  { ad: 'Giyim', grup: 'App', ciro: 48519, adet: 8, gor: 1986 },
  { ad: 'Aksesuar', grup: 'ACC', ciro: 28691, adet: 17, gor: 1542 },
  { ad: 'Unisex', grup: 'FTW', ciro: 10898, adet: 4, gor: 2582 },
];

/* ── Yardımcılar ─────────────────────────────────────────────────────────── */
const tl = (n) => '₺' + Math.round(n).toLocaleString('tr-TR');
const sayi = (n) => Math.round(n).toLocaleString('tr-TR');
const kisa = (n) => (n >= 1000000 ? (n / 1000000).toFixed(1).replace('.', ',') + 'M' : n >= 1000 ? Math.round(n / 1000) + 'K' : String(Math.round(n)));
const yuzde = (p, t) => (t ? (p / t) * 100 : 0);
const delta = (yeni, eski) => (eski ? ((yeni - eski) / eski) * 100 : null);
const kurus = (n) => '₺' + n.toFixed(2).replace('.', ',');
const virgul = (n, b = 2) => n.toFixed(b).replace('.', ',');

const satirlar = (f) => PLAN.filter(f);
const topla = (rows, alan) => rows.reduce((a, r) => a + (r[alan] || 0), 0);
const tik = (r) => (r.cpc ? r.butce / r.cpc : 0);
const gosterim = (r) => (r.cpm ? (r.butce / r.cpm) * 1000 : 0);
const izlenme = (r) => (r.cpv ? r.butce / r.cpv : 0);

const ciktiMetni = (r) => {
  const p = [`${sayi(gosterim(r))} gösterim`];
  if (r.cpc) p.push(`${sayi(tik(r))} tıklama · ${kurus(r.cpc)} CPC`);
  if (r.cpv) p.push(`${sayi(izlenme(r))} izlenme · ${kurus(r.cpv)} CPV`);
  return p.join(' · ');
};

const KAMPANYA_BUTCE = topla(PLAN, 'butce');
const TOPLAM_BUTCE = KAMPANYA_BUTCE + REZERV;

/* ═══════════════════════════ ALT BİLEŞENLER ═══════════════════════════ */

/* ── Mevsim eğrisi — GA4 aylık ciro + Eylül hedefi ──────────────────────── */
function MevsimGrafik() {
  const W = 900, H = 250, PL = 52, PR = 16, PT = 22, PB = 40;
  const veri = [...CIRO_SERI, { y: 2026, a: 9, v: HEDEF_EYLUL, hedef: true }];
  const maks = 2250000;
  const iw = W - PL - PR, ih = H - PT - PB;
  const bw = iw / veri.length;
  const y = (v) => PT + ih - (v / maks) * ih;
  const gridler = [0, 750000, 1500000, 2250000];

  return (
    <div className="overflow-x-auto">
      <svg viewBox={`0 0 ${W} ${H}`} className="w-full min-w-[560px]" style={{ height: 'auto' }}>
        {gridler.map((g) => (
          <g key={g}>
            <line x1={PL} y1={y(g)} x2={W - PR} y2={y(g)} stroke="#e5e7eb" strokeWidth="1" />
            <text x={PL - 8} y={y(g) + 4} textAnchor="end" fontSize="10" fill="#9ca3af">{g === 0 ? '0' : kisa(g)}</text>
          </g>
        ))}
        {veri.map((d, i) => {
          const x = PL + i * bw + bw * 0.18;
          const w = bw * 0.64;
          const top = y(d.v);
          return (
            <g key={i}>
              <rect
                x={x} y={top} width={w} height={Math.max(1, PT + ih - top)}
                fill={d.hedef ? '#fef3c7' : '#166534'}
                stroke={d.hedef ? '#d97706' : 'none'}
                strokeWidth={d.hedef ? 1.5 : 0}
                strokeDasharray={d.hedef ? '3 2.5' : undefined}
                rx="1"
              />
              {(d.v === 2170688 || d.a === 8 || d.hedef) && (
                <text x={x + w / 2} y={top - 5} textAnchor="middle" fontSize="9.5"
                      fill={d.hedef ? '#b45309' : '#166534'} fontWeight="600">
                  {kisa(d.v)}{d.hedef ? '*' : ''}
                </text>
              )}
              <text x={x + w / 2} y={PT + ih + 14} textAnchor="middle" fontSize="9.5"
                    fill={d.hedef ? '#b45309' : '#6b7280'} fontWeight={d.hedef ? '700' : '400'}>
                {AY_KISA[d.a]}
              </text>
              {(d.a === 1 || i === 0) && (
                <text x={x + w / 2} y={PT + ih + 27} textAnchor="middle" fontSize="9" fill="#9ca3af">{d.y}</text>
              )}
            </g>
          );
        })}
      </svg>
    </div>
  );
}

/* ── Arama hacmi grafiği — sezon kümesi, 23 ay ──────────────────────────── */
function AramaGrafik() {
  const W = 1120, H = 260, PL = 58, PR = 16, PT = 26, PB = 42;
  const maks = 80000;
  const iw = W - PL - PR, ih = H - PT - PB;
  const bw = iw / ARAMA_SERI.length;
  const y = (v) => PT + ih - (v / maks) * ih;
  const gridler = [0, 20000, 40000, 60000, 80000];

  return (
    <div className="overflow-x-auto">
      <svg viewBox={`0 0 ${W} ${H}`} className="w-full min-w-[760px]" style={{ height: 'auto' }}>
        {gridler.map((g) => (
          <g key={g}>
            <line x1={PL} y1={y(g)} x2={W - PR} y2={y(g)} stroke="#e5e7eb" strokeWidth="1" />
            <text x={PL - 8} y={y(g) + 4} textAnchor="end" fontSize="10" fill="#9ca3af">{g === 0 ? '0' : kisa(g)}</text>
          </g>
        ))}
        {ARAMA_SERI.map((d, i) => {
          const x = PL + i * bw + bw * 0.16;
          const w = bw * 0.68;
          const top = y(d.v);
          const agu = d.a === 8;
          const eyl = d.a === 9;
          const renk = agu ? '#b45309' : eyl ? '#f59e0b' : '#1d4ed8';
          return (
            <g key={i}>
              <rect x={x} y={top} width={w} height={Math.max(1, PT + ih - top)} fill={renk} rx="1" />
              {(agu || eyl) && (
                <text x={x + w / 2} y={top - 4} textAnchor="middle" fontSize="8.5"
                      fill={agu ? '#92400e' : '#b45309'} fontWeight="700">{kisa(d.v)}</text>
              )}
              {(agu || eyl || d.a === 1) && (
                <text x={x + w / 2} y={PT + ih + 13} textAnchor="middle" fontSize="8.5"
                      fill={agu || eyl ? '#b45309' : '#9ca3af'} fontWeight={agu || eyl ? '700' : '400'}>
                  {AY_KISA[d.a]}
                </text>
              )}
              {d.a === 1 && (
                <text x={x + w / 2} y={PT + ih + 26} textAnchor="middle" fontSize="9" fill="#9ca3af">{d.y}</text>
              )}
              {i === 0 && (
                <text x={x + w / 2} y={PT + ih + 26} textAnchor="middle" fontSize="9" fill="#9ca3af">{d.y}</text>
              )}
            </g>
          );
        })}
        <text x={PL} y={12} fontSize="10" fill="#6b7280">Aylık arama · beş çekirdek kelimenin toplamı · 48 ay</text>
        <g fontSize="9.5" fontWeight="600">
          <rect x={W - 210} y={5} width="9" height="9" fill="#b45309" rx="1" />
          <text x={W - 197} y={13} fill="#92400e">Ağustos</text>
          <rect x={W - 140} y={5} width="9" height="9" fill="#f59e0b" rx="1" />
          <text x={W - 127} y={13} fill="#b45309">Eylül</text>
        </g>
      </svg>
    </div>
  );
}

/* ── Ay içi dönem kartı ──────────────────────────────────────────────────── */
function Donem({ tarih, baslik, renk, pay, ozet, maddeler, uyari }) {
  const s = {
    yesil: 'border-emerald-200 bg-emerald-50 text-emerald-800',
    kirmizi: 'border-rose-200 bg-rose-50 text-rose-800',
    amber: 'border-amber-200 bg-amber-50 text-amber-800',
  }[renk];
  return (
    <div className={`rounded-lg border p-3.5 ${s.replace(/text-\S+/, '')}`}>
      <p className={`font-semibold mb-1 text-[12px] ${s.split(' ').find((c) => c.startsWith('text-'))}`}>
        {tarih} — {baslik} {pay && <span className="font-normal">({pay})</span>}
      </p>
      {uyari && (
        <p className="text-[11px] font-semibold text-rose-800 bg-white/70 border border-rose-200 rounded px-2 py-1 mb-2">
          {uyari}
        </p>
      )}
      <p className="text-[11px] leading-relaxed text-gray-700 mb-2">{ozet}</p>
      <ul className="text-[11px] leading-relaxed text-gray-700 list-disc pl-4 space-y-1">
        {maddeler.map((m, i) => <li key={i}>{m}</li>)}
      </ul>
    </div>
  );
}

/* ═══════════════════════════ SAYFA ═══════════════════════════ */

export default function HunterEylul2026MedyaPlani() {
  const mecraToplam = {
    google: topla(satirlar((r) => r.mecra === 'google'), 'butce'),
    meta: topla(satirlar((r) => r.mecra === 'meta'), 'butce'),
  };
  const amacToplam = {
    'Dönüşüm': topla(satirlar((r) => r.amac === 'Dönüşüm'), 'butce'),
    'Farkındalık': topla(satirlar((r) => r.amac === 'Farkındalık'), 'butce'),
    'Etkileşim': topla(satirlar((r) => r.amac === 'Etkileşim'), 'butce'),
  };
  const genelTik = PLAN.reduce((a, r) => a + tik(r), 0);
  const genelGosterim = PLAN.reduce((a, r) => a + gosterim(r), 0);
  const genelIzlenme = PLAN.reduce((a, r) => a + izlenme(r), 0);
  const markasizToplam = MARKASIZ_TALEP.reduce((a, r) => a + r.gos, 0);
  const katToplam = KATEGORI.reduce((a, r) => a + r.ciro, 0);
  const katAdet = KATEGORI.reduce((a, r) => a + r.adet, 0);
  const grupCiro = (g) => KATEGORI.filter((k) => k.grup === g).reduce((a, r) => a + r.ciro, 0);

  return (
    <div className="p-6 max-w-7xl mx-auto">
      <div className="bg-white rounded-2xl shadow-sm border overflow-hidden">

        {/* ── Başlık ── */}
        <div className="bg-white border-b p-5 flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="flex items-center gap-4">
            <div className="rounded-lg bg-[#1E4034] px-4 py-2.5">
              <span className="text-white font-bold tracking-[0.22em] text-sm">HUNTER</span>
            </div>
            <div className="ml-1">
              <h2 className="text-lg font-bold text-gray-800">HUNTER — Eylül 2026 Medya Planı</h2>
              <p className="text-sm text-gray-500">
                Sezona giriş + GANNI lansmanı · Google Ads • Meta Ads
              </p>
            </div>
          </div>
          <div className="flex items-center gap-3">
            <span className="inline-flex items-center px-3 py-1 bg-gray-100 text-gray-600 text-xs font-medium rounded-full border border-gray-200">
              Eylül 2026
            </span>
            <span className="inline-flex items-center px-3 py-1.5 bg-gray-800 text-white text-sm font-semibold rounded-full">
              Toplam: {tl(TOPLAM_BUTCE)}
            </span>
          </div>
        </div>

        <div className="p-6">

          {/* ══════════ KRİTİK BULGU ══════════ */}
          <div className="mb-6 p-4 rounded-xl bg-rose-50 border border-rose-200">
            <p className="text-xs font-semibold text-rose-900 mb-1">
              Bütçe dağılımından önce — Meta&#8217;da sekiz aydır harcanan {tl(402595)}&#8217;in karşılığı ölçülemiyor
            </p>
            <p className="text-[11px] text-rose-800 leading-relaxed">
              Ocak–Ağustos arası Meta&#8217;da <strong>{tl(402595)}</strong> harcandı; hem v1 hem v2 raporlamada
              <strong> satış ve gelir sıfır</strong>. Ağustos&#8217;ta Meta {sayi(AGUSTOS.meta.tik)} tık raporladı,
              GA4 aynı 90 günde <em>ig / paid</em> kaynağından yalnızca <strong>208 oturum</strong> gördü.
              Kampanyalar reklam metniyle adlandırılmış ve hepsi ₺5.000 sabit — CPM {tl(AGUSTOS.meta.cpm)}, CPC {kurus(AGUSTOS.meta.cpc)}.
              Bu değerler <strong>etkileşim satın alındığını</strong> söylüyor, satış değil.
              Bu bir performans sorunu değil <strong>kurgu ve ölçüm sorunu</strong>. Eylül&#8217;de Meta bütçesi
              ilk kez satın alma optimizasyonuyla çalışacak; piksel ve UTM tarafı da bu ay düzeltiliyor.
            </p>
          </div>

          {/* ══════════ ÖLÇEK NOTU ══════════ */}
          <div className="mb-6 p-4 rounded-xl bg-amber-50 border border-amber-200">
            <p className="text-xs font-semibold text-amber-800 mb-1">
              {tl(TOPLAM_BUTCE)} bir artış değil — Ağustos&#8217;un %{virgul(delta(TOPLAM_BUTCE, AGUSTOS_TOPLAM.harcama), 1)} üstünde
            </p>
            <p className="text-[11px] text-amber-700 leading-relaxed">
              Ağustos&#8217;ta hesapta gerçekleşen toplam harcama <strong>{tl(AGUSTOS_TOPLAM.harcama)}</strong>{' '}
              (Google {tl(AGUSTOS.google.harcama)} + Meta {tl(AGUSTOS.meta.harcama)}). Eylül planı{' '}
              <strong>{tl(TOPLAM_BUTCE)}</strong>, yani pratikte yatay. Sezonun döndüğü, GANNI lansmanının
              yapıldığı ve 28.000 adetlik stokun girdiği ayda bu bütçe <strong>sezona giriş bütçesidir,
              stok eritme bütçesi değildir</strong>. Planı buna göre kurduk: para yeni yere değil,
              <strong> doğru yere</strong> gidiyor. Bütçe artarsa nereye konacağı en altta yazılı.
            </p>
          </div>

          {/* ══════════ EYLÜL ODAĞI ══════════ */}
          <div className="mb-6 p-4 rounded-xl bg-blue-50 border border-blue-200">
            <p className="text-xs font-semibold text-blue-900 mb-1">Eylül Odağı — satış ayı değil, sezona giriş ayı</p>
            <p className="text-[11px] text-blue-800 leading-relaxed">
              Hunter&#8217;ın Türkiye cirosu takvimle değil hava durumuyla hareket ediyor: Kasım&#8217;da {tl(998284)},
              Şubat&#8217;ta {tl(2170688)}, Haziran&#8217;da {tl(112019)}. Eylül&#8217;ün işi ay içinde satış yapmak değil,
              <strong> Kasım–Şubat&#8217;ı kurmak</strong> — markasız talebi karşılamaya başlamak ve yeniden pazarlama
              havuzunu doldurmak. Sezon şimdiden dönmüş durumda: son 30 günde{' '}
              <strong>{sayi(GA4_SON30.oturum)} oturum</strong> ve <strong>{tl(GA4_SON30.ciro)}</strong> ciro,
              önceki 30 güne göre oturumda <strong>%{Math.round(delta(GA4_SON30.oturum, GA4_ONCEKI30.oturum))}</strong>,
              ciroda <strong>%{Math.round(delta(GA4_SON30.ciro, GA4_ONCEKI30.ciro))}</strong> artış.
              Bunun arama tarafındaki karşılığı <strong>dört yıldır aynı</strong>: sezon kümesinde Ağustos&#8594;Eylül
              çarpanı 2022&#8217;den beri <strong>3,1× · 3,6× · 4,2× · 4,1×</strong> — yani Eylül&#8217;de talep
              üç-dört katına çıkıyor ve bu tek yılın tesadüfü değil.
              Ayın ikinci gündemi <strong>GANNI</strong>: lansman 14 Eylül, ürünler 20 Eylül — aradaki altı gün planın en kritik yeri.
            </p>
          </div>

          {/* ══════════ MEVSİM EĞRİSİ ══════════ */}
          <div className="mb-6 rounded-xl border border-slate-200 overflow-hidden">
            <div className="bg-slate-100 px-4 py-2.5 text-xs font-semibold text-gray-800">
              Mevsim eğrisi 1/2 — sitenin AYLIK CİROSU (GA4), Eylül 2025 → Ağustos 2026
              <span className="block font-normal text-[11px] text-gray-500 mt-0.5">
                Bu grafik arama hacmi değil, sitede gerçekleşen satış tutarıdır. Arama hacmi hemen altında.
              </span>
            </div>
            <div className="p-4 bg-white">
              <MevsimGrafik />
            </div>
            <div className="px-4 py-2.5 bg-blue-50 border-t border-blue-100 text-[11px] text-blue-800 leading-relaxed">
              <strong>Eylül 2025&#8217;in düşük görünmesi mevsimsellik değil:</strong> site o ay yeni açılmıştı ve
              ay boyunca yalnızca <strong>689 oturum</strong> aldı — {tl(6700)} ciro bu yüzden. Ekim&#8217;de {tl(118388)},
              Kasım&#8217;da {tl(998284)} olması sezonun değil <strong>sitenin kendisinin</strong> açılmasıdır.
              Bu yüzden <strong>Eylül 2026&#8217;yı Eylül 2025 ile kıyaslamıyoruz</strong>; sezon okumasını bir alttaki
              arama hacmi grafiğinden yapıyoruz, o seri siteden bağımsızdır.
              Gerçek mevsim sinyali şurada: zirve <strong>Şubat 2026 {tl(2170688)}</strong>, dip{' '}
              <strong>Haziran 2026 {tl(112019)}</strong> — arada <strong>19 kat</strong> var.
              Ağustos {tl(GA4_AGUSTOS.ciro)} ile toparlanmaya başladı.
              Taralı sütun <strong>bu planın Eylül hedefidir</strong> ({tl(HEDEF_EYLUL)}), gerçekleşme değil.
            </div>
          </div>

          {/* ══════════ ARAMA HACMİ ══════════ */}
          <div className="mb-6 rounded-xl border border-slate-200 overflow-hidden">
            <div className="bg-slate-100 px-4 py-2.5 text-xs font-semibold text-gray-800">
              Mevsim eğrisi 2/2 — ARAMA HACMİ (Google Keyword Planner), Ağustos 2022 → Temmuz 2026
              <span className="block font-normal text-[11px] text-gray-500 mt-0.5">
                Türkiye + Türkçe · yalnızca Google arama ağı · beş çekirdek kelimenin aylık toplamı
              </span>
            </div>
            <div className="p-4 bg-white">
              <AramaGrafik />
            </div>
            <div className="px-4 py-3 bg-amber-50 border-t border-amber-100 text-[11px] text-amber-900 leading-relaxed">
              <strong>Planın tek cümlelik gerekçesi bu grafik — ve dört yıldır aynı.</strong> Koyu turuncu sütunlar Ağustos,
              açık turuncu olanlar Eylül. Her yıl aynı şey oluyor: Ağustos dipte, Eylül üç-dört katı.
              2022&#8217;de {sayi(14300)}&#8594;{sayi(44600)}, 2023&#8217;te {sayi(7820)}&#8594;{sayi(28300)},
              2024&#8217;te {sayi(7990)}&#8594;{sayi(33800)}, 2025&#8217;te {sayi(7180)}&#8594;{sayi(29600)}.
              Eylül&#8217;de kampanyaların yayında olmasının sebebi ay içinde satış yapmak değil,{' '}
              <strong>Ekim ihalesine öğrenmesini bitirmiş kampanyalarla girmek</strong>. Ekim&#8217;de sıfırdan
              kampanya açmak, hacmin yıla göre 4–11 katına çıktığı ayı öğrenme aşamasında geçirmek demektir.
            </div>
          </div>

          {/* ══════════ DÖRT AĞUSTOS ══════════ */}
          <div className="mb-6 rounded-xl border overflow-hidden">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800 flex items-center justify-between flex-wrap gap-2">
              <span>Dört Ağustos — sıçrama tek yılın tesadüfü değil</span>
              <span className="text-[11px] font-medium text-gray-500">Sezon kümesi · beş çekirdek kelimenin toplamı</span>
            </div>
            <div className="overflow-x-auto">
              <table className="min-w-full text-[11px]">
                <thead className="bg-gray-50 text-gray-500">
                  <tr>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider">Yıl</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Ağustos</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Eylül</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Ekim</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Ağu→Eyl</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Ağu→Eki</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-gray-700">
                  {DORT_AGUSTOS.map((r) => (
                    <tr key={r.yil} className="hover:bg-gray-50">
                      <td className="px-4 py-2 font-semibold text-gray-800">{r.yil}</td>
                      <td className="px-4 py-2 text-right tabular-nums">{sayi(r.agu)}</td>
                      <td className="px-4 py-2 text-right tabular-nums font-semibold">{sayi(r.eyl)}</td>
                      <td className="px-4 py-2 text-right tabular-nums">{sayi(r.eki)}</td>
                      <td className="px-4 py-2 text-right tabular-nums font-bold text-emerald-700">{virgul(r.eyl / r.agu, 1)}×</td>
                      <td className="px-4 py-2 text-right tabular-nums text-gray-500">{virgul(r.eki / r.agu, 1)}×</td>
                    </tr>
                  ))}
                  <tr className="bg-amber-50 border-t-2 border-amber-300">
                    <td className="px-4 py-2 font-semibold text-amber-900">
                      2026
                      <span className="block text-[10px] font-normal text-amber-700">tahmin</span>
                    </td>
                    <td className="px-4 py-2 text-right tabular-nums text-amber-900">
                      ~{sayi(TEMMUZ_2026 * 2.27)}
                      <span className="block text-[10px] text-amber-700">Tem {sayi(TEMMUZ_2026)} × 2,3</span>
                    </td>
                    <td className="px-4 py-2 text-right tabular-nums font-bold text-amber-900">
                      ~{sayi(TEMMUZ_2026 * 2.27 * 3.75)}
                    </td>
                    <td className="px-4 py-2 text-right text-amber-700">—</td>
                    <td className="px-4 py-2 text-right tabular-nums font-bold text-amber-900">3,75×</td>
                    <td className="px-4 py-2 text-right text-amber-700">—</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="px-4 py-3 bg-emerald-50 border-t border-emerald-100 text-[11px] text-emerald-900 leading-relaxed">
              <strong>Ağustos&#8594;Eylül çarpanı dört yıldır {virgul(3.1, 1)}–{virgul(4.2, 1)} bandında</strong>{' '}
              ({DORT_AGUSTOS.map((r) => virgul(r.eyl / r.agu, 1) + '×').join(' · ')}), ortalama <strong>{virgul(
                DORT_AGUSTOS.reduce((a, r) => a + r.eyl / r.agu, 0) / DORT_AGUSTOS.length, 2)}×</strong>.
              Bu bir tesadüf değil, tekrar eden bir desen — ve Eylül bütçesinin gerekçesi tam olarak budur.
              Ağustos&#8594;<strong>Ekim</strong> çarpanı ise oynak ({DORT_AGUSTOS.map((r) => virgul(r.eki / r.agu, 1) + '×').join(' · ')}),
              çünkü Ekim zirvesi <strong>yağmurun ne zaman başladığına</strong> bağlı. Bu yüzden taahhüdümüzü Eylül
              çarpanına veriyoruz, Ekim&#8217;e vermiyoruz.
            </div>
            <div className="px-4 py-3 bg-amber-50 border-t border-amber-100 text-[11px] text-amber-900 leading-relaxed">
              <strong>Ağustos 2026 rakamı henüz Keyword Planner&#8217;da yok</strong> — seri ~1-2 ay gecikmeli biter,
              elimizdeki son ay Temmuz 2026 ({sayi(TEMMUZ_2026)}). Temmuz&#8594;Ağustos çarpanı da istikrarlı:{' '}
              {TEMMUZ_AGUSTOS.map((r, i) => (
                <span key={r.yil}>{i > 0 ? ' · ' : ''}{r.yil} {virgul(r.agu / r.tem, 1)}×</span>
              ))}. Tablodaki 2026 satırı bu iki çarpandan türetilmiş bir <strong>tahmindir</strong>, gerçekleşme değil;
              Ağustos verisi Keyword Planner&#8217;a düştüğünde bu satırı gerçek rakamla değiştireceğiz.
            </div>
          </div>

          {/* ══════════ MARKA MI KATEGORİ Mİ ══════════ */}
          <div className="mb-6 rounded-xl border overflow-hidden">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800 flex items-center justify-between flex-wrap gap-2">
              <span>Büyüyen ne? — aynı ayın (Temmuz) dört yılı</span>
              <span className="text-[11px] font-medium text-gray-500">Mevsim etkisini sıfırlamak için hep aynı ay karşılaştırıldı</span>
            </div>
            <div className="overflow-x-auto">
              <table className="min-w-full text-[11px]">
                <thead className="bg-gray-50 text-gray-500">
                  <tr>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider">Kelime</th>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider">Tip</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Tem 23</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Tem 24</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Tem 25</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Tem 26</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">3 yılda</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-gray-700">
                  {TEMMUZ_KARSILASTIRMA.map((k) => {
                    const d = delta(k.y26, k.y23);
                    return (
                      <tr key={k.kw} className="hover:bg-gray-50">
                        <td className="px-4 py-2 font-medium text-gray-800">{k.kw}</td>
                        <td className="px-4 py-2">
                          <span className={`inline-flex items-center px-2 py-0.5 rounded-md border text-[10px] font-medium ${
                            k.tip === 'marka' ? 'bg-blue-50 text-blue-700 border-blue-200' : 'bg-emerald-50 text-emerald-700 border-emerald-200'}`}>
                            {k.tip}
                          </span>
                        </td>
                        <td className="px-4 py-2 text-right tabular-nums text-gray-500">{sayi(k.y23)}</td>
                        <td className="px-4 py-2 text-right tabular-nums text-gray-500">{sayi(k.y24)}</td>
                        <td className="px-4 py-2 text-right tabular-nums text-gray-500">{sayi(k.y25)}</td>
                        <td className="px-4 py-2 text-right tabular-nums font-semibold text-gray-900">{sayi(k.y26)}</td>
                        <td className={`px-4 py-2 text-right tabular-nums font-bold ${d > 0 ? 'text-emerald-700' : 'text-rose-700'}`}>
                          {d > 0 ? '+' : ''}%{Math.round(d)}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="px-4 py-3 bg-blue-50 border-t border-blue-100 text-[11px] text-blue-900 leading-relaxed">
              <strong>Büyüyen kategori değil, Hunter&#8217;ın kendisi.</strong> Marka kelimeleri üç yılda{' '}
              <strong>iki katından fazla</strong> arttı (&#8220;hunter çizme&#8221; {sayi(880)}&#8594;{sayi(1900)},
              &#8220;hunter bot&#8221; {sayi(260)}&#8594;{sayi(720)}); markasız kategori kelimeleri ise{' '}
              <strong>geriledi</strong> (&#8220;yağmur çizmesi&#8221; {sayi(1600)}&#8594;{sayi(880)}).
              Bunun iki sonucu var. Bir: marka savunması gerçekten değerli, çünkü büyüyen talep sizin adınıza geliyor.
              İki: <strong>markasız arama bir dalgaya binmek değil, küçülen bir pastadan pay almaktır</strong> —
              bu yüzden markasız bütçeyi {tl(10000)} ile sınırlı tutuyoruz, sınırsız açmıyoruz.
            </div>
          </div>

          {/* ══════════ KELİME KELİME ══════════ */}
          <div className="mb-6 rounded-xl border overflow-hidden">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800 flex items-center justify-between flex-wrap gap-2">
              <span>Kelime kelime arama hacmi ve geçen yılın Eylül–Ekim sıçraması</span>
              <span className="text-[11px] font-medium text-gray-500">Keyword Planner · 3 Eylül 2026&#8217;da çekildi</span>
            </div>
            <div className="overflow-x-auto">
              <table className="min-w-full text-[11px]">
                <thead className="bg-gray-50 text-gray-500">
                  <tr>
                    <th className="px-3 py-2 text-left font-medium uppercase tracking-wider">Kelime</th>
                    <th className="px-3 py-2 text-left font-medium uppercase tracking-wider">Tip</th>
                    <th className="px-3 py-2 text-right font-medium uppercase tracking-wider">Tem 26<br /><span className="normal-case font-normal">son veri</span></th>
                    <th className="px-3 py-2 text-right font-medium uppercase tracking-wider">Ağu 25</th>
                    <th className="px-3 py-2 text-right font-medium uppercase tracking-wider">Eyl 25</th>
                    <th className="px-3 py-2 text-right font-medium uppercase tracking-wider">Eki 25</th>
                    <th className="px-3 py-2 text-right font-medium uppercase tracking-wider">Ağu→Eyl</th>
                    <th className="px-3 py-2 text-right font-medium uppercase tracking-wider">Rekabet</th>
                    <th className="px-3 py-2 text-right font-medium uppercase tracking-wider">Tepe teklif</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-gray-700">
                  {ARAMA_KELIMELER.map((k) => {
                    const kat = k.ey25 / k.ag25;
                    return (
                      <tr key={k.kw} className="hover:bg-gray-50">
                        <td className="px-3 py-2 font-medium text-gray-800">
                          {k.kw}
                          {k.karisik && (
                            <span className="block text-[10px] font-normal text-rose-700 mt-0.5">karışık niyet — aşağıdaki nota bakın</span>
                          )}
                        </td>
                        <td className="px-3 py-2">
                          <span className={`inline-flex items-center px-2 py-0.5 rounded-md border text-[10px] font-medium ${
                            k.tip === 'marka' ? 'bg-blue-50 text-blue-700 border-blue-200'
                            : k.tip === 'markasız' ? 'bg-emerald-50 text-emerald-700 border-emerald-200'
                            : 'bg-purple-50 text-purple-700 border-purple-200'}`}>
                            {k.tip}
                          </span>
                        </td>
                        <td className="px-3 py-2 text-right tabular-nums text-gray-500">{sayi(k.son)}</td>
                        <td className="px-3 py-2 text-right tabular-nums">{sayi(k.ag25)}</td>
                        <td className="px-3 py-2 text-right tabular-nums font-semibold">{sayi(k.ey25)}</td>
                        <td className="px-3 py-2 text-right tabular-nums font-semibold text-gray-900">{sayi(k.ek25)}</td>
                        <td className={`px-3 py-2 text-right tabular-nums font-semibold ${kat >= 2 ? 'text-emerald-700' : 'text-gray-500'}`}>
                          {virgul(kat, 1)}×
                        </td>
                        <td className={`px-3 py-2 text-right ${k.rekabet === 'HIGH' ? 'text-rose-700 font-semibold' : 'text-gray-500'}`}>{k.rekabet}</td>
                        <td className="px-3 py-2 text-right tabular-nums text-gray-500">{kurus(k.teklif)}</td>
                      </tr>
                    );
                  })}
                </tbody>
              </table>
            </div>
            <div className="px-4 py-3 bg-rose-50 border-t border-rose-100 text-[11px] text-rose-900 leading-relaxed">
              <strong>Çıplak &#8220;hunter&#8221; en büyük hacim ama en karışık niyet.</strong> Aylık {sayi(12100)} arama var —
              bunun önemli kısmı Hunter markası değil: <em>Hunter x Hunter</em> animesi ve avcılıkla ilgili aramalar.
              Kanıtı kendi verimizde: Search Console&#8217;da bu sorguda ortalama sıramız <strong>1,2</strong>,
              buna rağmen CTR yalnızca <strong>%5,5</strong> (19.080 gösterim, 1.059 tık). Birinci sıradayken kimse tıklamıyorsa,
              arayan kişi bizi aramıyordur. Rekabetin <strong>LOW</strong>, tepe teklifin ise {kurus(57.66)} olması da aynı şeyi söylüyor:
              çoğu arayan alışveriş niyetli değil.
              Temiz marka sinyali <strong>&#8220;hunter çizme&#8221;</strong> ve <strong>&#8220;hunter bot&#8221;</strong> —
              ikisi de Eylül&#8217;de {virgul(8100 / 2400, 1)}× ve {virgul(2400 / 1000, 1)}× sıçrıyor.
              <strong> Sonuç:</strong> marka kampanyası geniş eşlemede çalıştırılmıyor, exact ve phrase ile sınırlı tutuluyor;
              yukarıdaki sezon kümesi grafiğine de bu kelime dahil edilmedi, çünkü kümeyi şişirir.
            </div>
            <div className="px-4 py-3 bg-blue-50 border-t border-blue-100 text-[11px] text-blue-900 leading-relaxed">
              <strong>GANNI:</strong> aylık {sayi(3600)}–{sayi(6600)} bandında, mevsimsiz ve <strong>istikrarlı</strong> bir talep.
              Rekabet orta, tepe sayfa teklifi {kurus(53.20)} — yani pahalı ama küçük bir ihale. 14 Eylül lansmanı bu tabanın
              üstüne bir sıçrama bindirecek; <strong>{tl(3000)}</strong>&#8217;lik GANNI arama kampanyasının tek işi o sıçramanın
              pazaryerlerine değil bize gelmesi. Ürün 20 Eylül&#8217;de geldiği için kampanya <strong>10 Eylül&#8217;de</strong>{' '}
              açılıyor: öğrenmesini lansmandan önce bitirsin diye.
            </div>
            <div className="px-4 py-3 bg-emerald-50 border-t border-emerald-100 text-[11px] text-emerald-900 leading-relaxed">
              <strong>Marka talebi yıldan yıla büyüyor.</strong> Çıplak &#8220;hunter&#8221; kelimesinde aynı ayların iki yılı:{' '}
              {MARKA_BUYUME.map((m, i) => (
                <span key={m.ay}>
                  {i > 0 ? ' · ' : ''}<strong>{m.ay}</strong> {sayi(m.y24)} → {sayi(m.y25)} (%{Math.round(delta(m.y25, m.y24))})
                </span>
              ))}. Ekim&#8217;de talep bir yılda <strong>iki katından fazla</strong> arttı. Bu büyüme sizin lehinize
              çalışıyor ama <strong>karşılığını almak için ihalede olmak gerekiyor</strong> — markasız kümede bugün değiliz.
            </div>
          </div>

          {/* ══════════ AĞUSTOS → EYLÜL ══════════ */}
          <div className="mb-6 rounded-xl border border-slate-200 overflow-hidden">
            <div className="bg-slate-100 px-4 py-2.5 text-xs font-semibold text-gray-800">Ağustos 2026 gerçekleşen → Eylül 2026 planı (mecra bazında)</div>
            <div className="overflow-x-auto">
              <table className="min-w-full text-[11px]">
                <thead className="bg-gray-50 text-gray-500">
                  <tr>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider">Mecra</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Ağu harcama</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Ağu CPC</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Ağu CPM</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Ağu dönüşüm</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Eylül plan</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Değişim</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-gray-700">
                  {['google', 'meta'].map((m) => {
                    const a = AGUSTOS[m], pl = mecraToplam[m], d = delta(pl, a.harcama);
                    return (
                      <tr key={m}>
                        <td className="px-4 py-2 font-medium">
                          <span className="inline-flex items-center gap-2">
                            <img src={MECRA[m].logo} alt="" className="w-4 h-4 object-contain" />{MECRA[m].ad}
                            <span className="text-gray-400 font-normal">· {a.kampanya} kampanya</span>
                          </span>
                        </td>
                        <td className="px-4 py-2 text-right">{tl(a.harcama)}</td>
                        <td className="px-4 py-2 text-right">{kurus(a.cpc)}</td>
                        <td className="px-4 py-2 text-right">{kurus(a.cpm)}</td>
                        <td className={`px-4 py-2 text-right font-semibold ${a.donusum ? 'text-gray-700' : 'text-rose-700'}`}>
                          {a.donusum ? sayi(a.donusum) : '0 · kayıt yok'}
                        </td>
                        <td className="px-4 py-2 text-right font-semibold">{tl(pl)}</td>
                        <td className={`px-4 py-2 text-right ${d >= 0 ? 'text-emerald-600' : 'text-red-600'}`}>
                          {`${d > 0 ? '+' : ''}${Math.round(d)}%`}
                        </td>
                      </tr>
                    );
                  })}
                  <tr>
                    <td className="px-4 py-2 font-medium text-gray-500">Rezerv <span className="text-gray-400 font-normal">· 20 Eylül&#8217;de dağıtılır</span></td>
                    <td className="px-4 py-2 text-right text-gray-400">—</td>
                    <td className="px-4 py-2 text-right text-gray-400">—</td>
                    <td className="px-4 py-2 text-right text-gray-400">—</td>
                    <td className="px-4 py-2 text-right text-gray-400">—</td>
                    <td className="px-4 py-2 text-right font-semibold">{tl(REZERV)}</td>
                    <td className="px-4 py-2 text-right text-blue-600">yeni</td>
                  </tr>
                  <tr className="bg-gray-50 font-semibold text-gray-800">
                    <td className="px-4 py-2">Toplam</td>
                    <td className="px-4 py-2 text-right">{tl(AGUSTOS_TOPLAM.harcama)}</td>
                    <td className="px-4 py-2 text-right">{kurus(AGUSTOS_TOPLAM.cpc)}</td>
                    <td className="px-4 py-2 text-right">{kurus(AGUSTOS_TOPLAM.cpm)}</td>
                    <td className="px-4 py-2 text-right">{sayi(AGUSTOS.google.donusum)}</td>
                    <td className="px-4 py-2 text-right">{tl(TOPLAM_BUTCE)}</td>
                    <td className="px-4 py-2 text-right text-emerald-700">+{virgul(delta(TOPLAM_BUTCE, AGUSTOS_TOPLAM.harcama), 1)}%</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="px-4 py-2.5 bg-amber-50 border-t border-amber-100 text-[11px] text-amber-800 leading-relaxed">
              Ağustos&#8217;ta GA4&#8217;te <strong>{tl(GA4_AGUSTOS.ciro)}</strong> ciro ve <strong>{GA4_AGUSTOS.urun} ürün satışı</strong>{' '}
              görüldü ({sayi(GA4_AGUSTOS.oturum)} oturum). Birleşik ROAS <strong>{virgul(GA4_AGUSTOS.ciro / AGUSTOS_TOPLAM.harcama)}</strong>.
              Dikkat: Google Ads kendi raporunda Ağustos için {tl(AGUSTOS.google.ciro)} dönüşüm değeri veriyor — bu, <strong>sitenin
              tamamının cirosunun 2,5 katı</strong>. Atıf şişmesi var; bu planda ciro kıyasları <strong>GA4 üzerinden</strong> yapılmıştır.
            </div>
          </div>

          {/* ══════════ AMACA GÖRE DAĞILIM ══════════ */}
          <div className="mb-6 rounded-xl border overflow-hidden">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Kampanya amacına göre bütçe dağılımı</div>
            <div className="p-4 bg-white">
              <div className="flex h-8 rounded-md overflow-hidden border border-gray-200 mb-3">
                {[
                  { k: 'Dönüşüm', renk: '#059669' },
                  { k: 'Farkındalık', renk: '#dc2626' },
                  { k: 'Etkileşim', renk: '#db2777' },
                  { k: 'Rezerv', renk: '#94a3b8', v: REZERV },
                ].map((s) => {
                  const v = s.v != null ? s.v : amacToplam[s.k];
                  const p = yuzde(v, TOPLAM_BUTCE);
                  return (
                    <div key={s.k} style={{ width: `${p}%`, background: s.renk }}
                         className="flex items-center justify-center text-white text-[10px] font-semibold overflow-hidden whitespace-nowrap">
                      {p > 9 ? `${Math.round(p)}%` : ''}
                    </div>
                  );
                })}
              </div>
              <div className="overflow-x-auto">
                <table className="min-w-full text-[11px]">
                  <thead className="bg-gray-50 text-gray-500">
                    <tr>
                      <th className="px-3 py-2 text-left font-medium uppercase tracking-wider">Amaç</th>
                      <th className="px-3 py-2 text-right font-medium uppercase tracking-wider">Bütçe</th>
                      <th className="px-3 py-2 text-right font-medium uppercase tracking-wider">Pay</th>
                      <th className="px-3 py-2 text-left font-medium uppercase tracking-wider">Ne için</th>
                    </tr>
                  </thead>
                  <tbody className="bg-white divide-y divide-gray-100 text-gray-700">
                    <tr>
                      <td className="px-3 py-2"><Amac tip="Dönüşüm" /></td>
                      <td className="px-3 py-2 text-right font-semibold">{tl(amacToplam['Dönüşüm'])}</td>
                      <td className="px-3 py-2 text-right">%{Math.round(yuzde(amacToplam['Dönüşüm'], TOPLAM_BUTCE))}</td>
                      <td className="px-3 py-2 text-gray-600">Var olan talebi hasat etmek — marka, markasız arama, katalog</td>
                    </tr>
                    <tr>
                      <td className="px-3 py-2"><Amac tip="Farkındalık" /></td>
                      <td className="px-3 py-2 text-right font-semibold">{tl(amacToplam['Farkındalık'])}</td>
                      <td className="px-3 py-2 text-right">%{Math.round(yuzde(amacToplam['Farkındalık'], TOPLAM_BUTCE))}</td>
                      <td className="px-3 py-2 text-gray-600">GANNI lansmanı ve 20 Eylül&#8217;de dönüştürülecek kitlenin kurulması</td>
                    </tr>
                    <tr>
                      <td className="px-3 py-2"><Amac tip="Etkileşim" /></td>
                      <td className="px-3 py-2 text-right font-semibold">{tl(amacToplam['Etkileşim'])}</td>
                      <td className="px-3 py-2 text-right">%{Math.round(yuzde(amacToplam['Etkileşim'], TOPLAM_BUTCE))}</td>
                      <td className="px-3 py-2 text-gray-600">Yalnızca kreatif testi — Ağustos&#8217;ta bütçenin tamamı buradaydı</td>
                    </tr>
                    <tr>
                      <td className="px-3 py-2 text-gray-500 font-medium">Rezerv</td>
                      <td className="px-3 py-2 text-right font-semibold">{tl(REZERV)}</td>
                      <td className="px-3 py-2 text-right">%{Math.round(yuzde(REZERV, TOPLAM_BUTCE))}</td>
                      <td className="px-3 py-2 text-gray-600">Peşinen dağıtılmıyor; 20 Eylül&#8217;de en iyi çalışan kaleme aktarılır</td>
                    </tr>
                    <tr className="bg-gray-50 font-semibold text-gray-800">
                      <td className="px-3 py-2">Toplam</td>
                      <td className="px-3 py-2 text-right">{tl(TOPLAM_BUTCE)}</td>
                      <td className="px-3 py-2 text-right">%100</td>
                      <td className="px-3 py-2"></td>
                    </tr>
                  </tbody>
                </table>
              </div>
              <p className="text-[11px] text-gray-500 mt-3 leading-relaxed">
                Ağustos&#8217;ta Meta bütçesinin <strong>tamamı</strong> etkileşim/farkındalık tipindeydi ve karşılığı ölçülemedi.
                Eylül&#8217;de dönüşüm amaçlı bütçe payı <strong>%{Math.round(yuzde(amacToplam['Dönüşüm'], TOPLAM_BUTCE))}</strong>&#8217;e çıkıyor.
              </p>
            </div>
          </div>

          {/* ══════════ MEDYA PLANI TABLOSU ══════════ */}
          <div className="mb-6 rounded-xl border overflow-hidden">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800 flex items-center justify-between flex-wrap gap-2">
              <span>Medya Planı — HUNTER Eylül 2026</span>
              <span className="text-[11px] font-medium text-gray-500">{PLAN.length} kampanya · birim maliyetler SEZON İÇİ, Ağustos gerçekleşeninden yukarı düzeltildi</span>
            </div>
            <div className="px-4 py-3 bg-amber-50 border-b border-amber-200 text-[11px] text-amber-900 leading-relaxed">
              <strong>Birim maliyetler sezon seviyesine çekildi.</strong> Ağustos ölü sezonun dibidir; oradaki CPC&#8217;leri
              Eylül&#8217;e taşımak tıklama tahminini şişirir. Arama hacmi Ağustos&#8594;Eylül <strong>3,75 katına</strong>{' '}
              çıkarken ihale fiyatı sabit kalmaz. Çıpamız Keyword Planner&#8217;ın tepe sayfa teklifleri:{' '}
              <strong>yağmur botu {kurus(14.09)} · yağmur çizmesi {kurus(10.95)} · hunter çizme {kurus(9.59)} · ganni {kurus(53.20)}</strong>.
              Sezon içi gerçekleşen CPC bunların altında kalır ama Ağustos&#8217;un belirgin üstündedir.
              Turuncu satırlar hangi rakamdan hangi rakama çıkıldığını tek tek yazıyor.
              <strong> Sonuç: aynı bütçe daha az tık alıyor</strong> — düzeltme öncesi tahmin {sayi(17901)} tıklamaydı,
              şimdi {sayi(genelTik)} ({Math.round(delta(genelTik, 17901))}%). Bu bir kötüleşme değil,{' '}
              <strong>daha dürüst bir tahmin</strong>.
            </div>
            <div className="overflow-x-auto">
              <table className="min-w-full text-[11px]">
                <thead className="bg-gray-50 text-gray-500">
                  <tr>
                    <th className="px-3 py-2 text-left font-medium uppercase tracking-wider">Kampanya</th>
                    <th className="px-3 py-2 text-left font-medium uppercase tracking-wider">Hedef kitle</th>
                    <th className="px-3 py-2 text-left font-medium uppercase tracking-wider">Amaç</th>
                    <th className="px-3 py-2 text-right font-medium uppercase tracking-wider">Bütçe</th>
                    <th className="px-3 py-2 text-left font-medium uppercase tracking-wider">Tahmini çıktı</th>
                    <th className="px-3 py-2 text-left font-medium uppercase tracking-wider">Açılış</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-gray-700">
                  {['google', 'meta'].map((m) => {
                    const rows = satirlar((r) => r.mecra === m);
                    const mButce = topla(rows, 'butce');
                    return (
                      <React.Fragment key={m}>
                        <tr className="bg-gray-100/70">
                          <td colSpan="3" className="px-3 py-2 font-semibold text-gray-800">
                            <span className="inline-flex items-center gap-2">
                              <img src={MECRA[m].logo} alt="" className="w-4 h-4 object-contain" />{MECRA[m].ad}
                            </span>
                          </td>
                          <td className="px-3 py-2 text-right font-semibold text-gray-800">{tl(mButce)}</td>
                          <td colSpan="2" className="px-3 py-2 text-gray-500">%{Math.round(yuzde(mButce, TOPLAM_BUTCE))} · {rows.length} kampanya</td>
                        </tr>
                        {rows.map((r) => (
                          <tr key={r.kampanya} className="hover:bg-gray-50 align-top">
                            <td className="px-3 py-2.5 font-medium text-gray-800 min-w-[180px]">
                              {r.kampanya}
                              <span className="block text-[10.5px] text-gray-500 font-normal mt-1.5 leading-relaxed max-w-[280px]">{r.gerekce}</span>
                            </td>
                            <td className="px-3 py-2.5 text-gray-600 max-w-[190px]">{r.kitle}</td>
                            <td className="px-3 py-2.5"><Amac tip={r.amac} /></td>
                            <td className="px-3 py-2.5 text-right font-semibold whitespace-nowrap">{tl(r.butce)}</td>
                            <td className="px-3 py-2.5 text-gray-600 whitespace-nowrap">
                              {ciktiMetni(r)}
                              {r.kaynak === 'sezon' && (
                                <span className="block text-[10px] text-amber-700 mt-0.5">
                                  sezon düzeltmesi: {kurus(r.taban)} ({r.tabanAd}) &#8594; {kurus(r.cpc || r.cpm)}
                                  {' '}· {virgul((r.cpc || r.cpm) / r.taban, 1)}×
                                </span>
                              )}
                              {r.kaynak === 'benchmark' && (
                                <span className="block text-[10px] text-gray-400 mt-0.5">
                                  birim maliyet: pazar benchmark&#8217;ı{r.tabanAd ? ` · ${r.tabanAd}` : ''}
                                </span>
                              )}
                            </td>
                            <td className="px-3 py-2.5 text-gray-500 whitespace-nowrap">{r.donem}</td>
                          </tr>
                        ))}
                      </React.Fragment>
                    );
                  })}
                  <tr className="bg-gray-100 font-semibold text-gray-800">
                    <td className="px-3 py-2.5" colSpan="3">Kampanya toplamı</td>
                    <td className="px-3 py-2.5 text-right">{tl(KAMPANYA_BUTCE)}</td>
                    <td className="px-3 py-2.5" colSpan="2">
                      {sayi(genelGosterim)} gösterim · {sayi(genelTik)} tıklama · {sayi(genelIzlenme)} izlenme
                    </td>
                  </tr>
                  <tr className="bg-gray-50 text-gray-700">
                    <td className="px-3 py-2.5" colSpan="3">Rezerv (20 Eylül&#8217;de dağıtılır)</td>
                    <td className="px-3 py-2.5 text-right font-semibold">{tl(REZERV)}</td>
                    <td className="px-3 py-2.5 text-gray-500" colSpan="2">Stok girdiğinde en iyi çalışan kaleme aktarılır</td>
                  </tr>
                  <tr className="bg-gray-800 text-white font-semibold">
                    <td className="px-3 py-2.5" colSpan="3">GENEL TOPLAM</td>
                    <td className="px-3 py-2.5 text-right">{tl(TOPLAM_BUTCE)}</td>
                    <td className="px-3 py-2.5" colSpan="2"></td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>

          {/* ══════════ GANNI TAKVİMİ ══════════ */}
          <div className="mb-6 rounded-xl border overflow-hidden">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Ay içi takvim — GANNI lansmanı ve altı günlük boşluk</div>
            <div className="p-4 bg-white grid gap-3 md:grid-cols-3">
              <Donem
                renk="yesil" tarih="1–13 Eylül" baslik="Sezon girişi ve ölçüm onarımı"
                pay={`%35 · ${tl(TOPLAM_BUTCE * 0.35)}`}
                ozet="GANNI'den bağımsız olarak sezonluk talebi karşılamaya başlıyoruz. Meta piksel ve UTM düzeltmesi de bu hafta yapılıyor."
                maddeler={[
                  'Markasız arama kampanyası 1 Eylül’de açılıyor — öğrenmesini lansmandan önce bitirmesi için',
                  'Meta’daki ₺5.000’lik boost’lu gönderiler durduruluyor, katalog satış kurgusu kuruluyor',
                  'PMax bütçesi feed düzeldikçe kademeli açılıyor',
                  'GANNI arama kampanyası 10 Eylül’de açılıyor',
                ]}
              />
              <Donem
                renk="kirmizi" tarih="14–19 Eylül" baslik="Lansman var, stok yok"
                pay={`%25 · ${tl(TOPLAM_BUTCE * 0.25)}`}
                uyari="Bu altı günde satın alma optimizasyonlu kampanyaya GANNI ürünü konmaz."
                ozet="Lansman 14 Eylül, ürünlerin büyük bölümü 20 Eylül. Aradaki pencerede stokta olmayan SKU'ya bütçe harcarsak hem parayı hem öğrenme sinyalini kaybederiz."
                maddeler={[
                  'GANNI ürünleri katalog satış kampanyasına HENÜZ dahil edilmiyor',
                  'Meta’da erişim + video kurgusu; hedef satış değil izinli kitle',
                  'Sitede "haber ver / ön kayıt" alanı — 20 Eylül’de retargeting kaynağı olur',
                  'Google’da GANNI marka koruması pazaryerlerine karşı açık',
                ]}
              />
              <Donem
                renk="amber" tarih="20–30 Eylül" baslik="Stok girişi ve satışa geçiş"
                pay={`%40 · ${tl(TOPLAM_BUTCE * 0.40)}`}
                ozet="Ürünler girer girmez kurgu satışa çevriliyor. Rezerv bütçe bu tarihte, o güne kadarki veriye bakılarak dağıtılıyor."
                maddeler={[
                  'GANNI katalogda; 14–19 aralığında biriken kitleye yeniden pazarlama açılıyor',
                  `Rezerv ${tl(REZERV)} en iyi çalışan kaleme aktarılıyor`,
                  'Originals ve Downpour yeni modelleri ayrı ürün setleri olarak ayrılıyor',
                  'Ekim’e devredilecek kitle havuzları burada oluşuyor',
                ]}
              />
            </div>
          </div>

          {/* ══════════ MARKASIZ TALEP ══════════ */}
          <div className="mb-6 rounded-xl border overflow-hidden">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800 flex items-center justify-between flex-wrap gap-2">
              <span>Markasız talep — reklamla kapatılacak en net boşluk</span>
              <span className="text-[11px] font-medium text-gray-500">Search Console · son 90 gün · marka içeren sorgular hariç</span>
            </div>
            <div className="overflow-x-auto">
              <table className="min-w-full text-[11px]">
                <thead className="bg-gray-50 text-gray-500">
                  <tr>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider">Sorgu</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Gösterim</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Tık</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Ort. sıra</th>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider">Durum</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-gray-700">
                  {MARKASIZ_TALEP.map((r) => (
                    <tr key={r.q} className="hover:bg-gray-50">
                      <td className="px-4 py-2 font-medium text-gray-800">{r.q}</td>
                      <td className="px-4 py-2 text-right tabular-nums">{sayi(r.gos)}</td>
                      <td className="px-4 py-2 text-right tabular-nums text-gray-500">{sayi(r.tik)}</td>
                      <td className={`px-4 py-2 text-right tabular-nums ${r.poz > 5 ? 'text-rose-700 font-semibold' : ''}`}>{virgul(r.poz, 1)}</td>
                      <td className="px-4 py-2 text-gray-500">{r.poz > 5 ? 'ilk sayfanın altında' : 'ilk sayfada, reklamsız'}</td>
                    </tr>
                  ))}
                  <tr className="bg-gray-50 font-semibold text-gray-800">
                    <td className="px-4 py-2">Toplam</td>
                    <td className="px-4 py-2 text-right tabular-nums">{sayi(markasizToplam)}</td>
                    <td className="px-4 py-2 text-right tabular-nums">{sayi(MARKASIZ_TALEP.reduce((a, r) => a + r.tik, 0))}</td>
                    <td className="px-4 py-2 text-right"></td>
                    <td className="px-4 py-2"></td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="px-4 py-2.5 bg-emerald-50 border-t border-emerald-100 text-[11px] text-emerald-900 leading-relaxed">
              <strong>{sayi(markasizToplam)} organik gösterim</strong> — ve bu <strong>ölü sezonun</strong> rakamı.
              Ortalama sıralamamız 5–7 bandında, yani ilk sayfanın altında; bu talebin karşılığını bugün almıyoruz.
              Aynı kümede çalışan <em>Search — Generic</em> kampanyası 30 Ocak – 8 Mayıs arasında{' '}
              <strong>{tl(12459)} harcayıp {tl(488585)}</strong> üretmişti (ROAS {virgul(39.2, 1)}) ve gösterim payının
              <strong> %72,3&#8217;ünü sıralamaya, %16,3&#8217;ünü bütçeye</strong> kaybediyordu. Doymamıştı, buna rağmen Mayıs&#8217;ta kapatıldı.
              Eylül planında <strong>{tl(10000)}</strong> ile geri açılıyor.
            </div>
          </div>

          {/* ══════════ ÜRÜN KIRILIMI ══════════ */}
          <div className="mb-6 rounded-xl border overflow-hidden">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800 flex items-center justify-between flex-wrap gap-2">
              <span>Ürün seti ağırlıkları — FTW / ACC / App</span>
              <span className="text-[11px] font-medium text-gray-500">GA4 · son 90 gün gerçekleşen ciro</span>
            </div>
            <div className="overflow-x-auto">
              <table className="min-w-full text-[11px]">
                <thead className="bg-gray-50 text-gray-500">
                  <tr>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider">Kategori</th>
                    <th className="px-4 py-2 text-left font-medium uppercase tracking-wider">Grup</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Ciro</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Pay</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Adet</th>
                    <th className="px-4 py-2 text-right font-medium uppercase tracking-wider">Sepet ort.</th>
                  </tr>
                </thead>
                <tbody className="bg-white divide-y divide-gray-100 text-gray-700">
                  {KATEGORI.map((k) => (
                    <tr key={k.ad} className="hover:bg-gray-50">
                      <td className="px-4 py-2 font-medium text-gray-800">{k.ad}</td>
                      <td className="px-4 py-2">
                        <span className="inline-flex items-center px-2 py-0.5 rounded-md border text-[10px] font-medium bg-gray-50 text-gray-600 border-gray-200">{k.grup}</span>
                      </td>
                      <td className="px-4 py-2 text-right tabular-nums font-semibold">{tl(k.ciro)}</td>
                      <td className="px-4 py-2 text-right tabular-nums">%{virgul(yuzde(k.ciro, katToplam), 1)}</td>
                      <td className="px-4 py-2 text-right tabular-nums text-gray-500">{k.adet}</td>
                      <td className="px-4 py-2 text-right tabular-nums text-gray-500">{tl(k.ciro / k.adet)}</td>
                    </tr>
                  ))}
                  <tr className="bg-gray-50 font-semibold text-gray-800">
                    <td className="px-4 py-2" colSpan="2">Toplam</td>
                    <td className="px-4 py-2 text-right tabular-nums">{tl(katToplam)}</td>
                    <td className="px-4 py-2 text-right">%100</td>
                    <td className="px-4 py-2 text-right tabular-nums">{katAdet}</td>
                    <td className="px-4 py-2 text-right tabular-nums">{tl(katToplam / katAdet)}</td>
                  </tr>
                </tbody>
              </table>
            </div>
            <div className="px-4 py-2.5 bg-blue-50 border-t border-blue-100 text-[11px] text-blue-800 leading-relaxed">
              Sizin kırılımınıza çevirirsek: <strong>FTW %{Math.round(yuzde(grupCiro('FTW'), katToplam))}</strong> ({tl(grupCiro('FTW'))}),{' '}
              <strong>App %{Math.round(yuzde(grupCiro('App'), katToplam))}</strong> ({tl(grupCiro('App'))}),{' '}
              <strong>ACC %{Math.round(yuzde(grupCiro('ACC'), katToplam))}</strong> ({tl(grupCiro('ACC'))}).
              PMax ürün grupları ve Meta katalog setleri bu ağırlıkla bölünüyor.
              Sepet ortalaması yönü teyit ediyor: kadın ve erkek ayakkabıda ₺7.100 civarı, çocukta {tl(1996)}, aksesuarda {tl(1688)} —
              yani <strong>ROAS hedefli kampanyalar kadın ayakkabı üzerine</strong>, erişim ve hacim kampanyaları çocuk ve aksesuar üzerine kuruluyor.
              En çok satan ürünler zaten <strong>Originals Wellington</strong> ve <strong>Downpour Termal</strong> — Eylül&#8217;de genişleyeceğini
              söylediğiniz iki seri.
            </div>
          </div>

          {/* ══════════ HEDEFLER ══════════ */}
          <div className="mb-6 rounded-xl border overflow-hidden">
            <div className="bg-slate-100 px-4 py-3 font-semibold text-gray-800">Eylül hedefleri</div>
            <div className="p-4 bg-white grid gap-3 sm:grid-cols-2 lg:grid-cols-4">
              {[
                { n: '₺350–380K', k: 'Müdahalesiz taban', a: 'Hiçbir şey değişmezse yalnızca mevsim etkisiyle beklenen Eylül cirosu.', vurgu: false },
                { n: '₺500–550K', k: 'Plan hedefi', a: 'Bu dağılım uygulanırsa ve Meta ölçümü düzelirse Eylül GA4 cirosu.', vurgu: true },
                { n: '6,7–7,3×', k: 'Birleşik ROAS', a: `Ağustos'un ${virgul(GA4_AGUSTOS.ciro / AGUSTOS_TOPLAM.harcama)}'sine karşılık. Artışın çoğu Meta'nın ölçülebilir hale gelmesinden.`, vurgu: true },
                { n: '%40', k: 'Markasız trafik payı', a: 'Ücretli aramada markasız kelimelerin hedef payı. Bugün sıfıra yakın.', vurgu: false },
              ].map((t) => (
                <div key={t.k} className={`rounded-lg border p-3.5 ${t.vurgu ? 'border-emerald-200 bg-emerald-50' : 'border-gray-200 bg-gray-50'}`}>
                  <p className={`text-xl font-bold tabular-nums ${t.vurgu ? 'text-emerald-700' : 'text-gray-800'}`}>{t.n}</p>
                  <p className="text-[10.5px] font-semibold uppercase tracking-wider text-gray-500 mt-1.5 mb-1">{t.k}</p>
                  <p className="text-[11px] text-gray-600 leading-relaxed">{t.a}</p>
                </div>
              ))}
            </div>
            <div className="px-4 py-3 bg-amber-50 border-t border-amber-100 text-[11px] text-amber-900 leading-relaxed">
              <strong>Bütçe artarsa:</strong> ilave her {tl(25000)}&#8217;in tamamını <strong>markasız aramaya ve PMax&#8217;e</strong> koymanızı
              öneririz — bu iki kalem de bugün doymamış durumda (sırasıyla %72,3 ve %75,3 sıralama kaybı). Marka savunmasına
              veya Meta erişimine ilave bütçe koymak Eylül&#8217;de karşılığını vermez. Ekim&#8217;den itibaren tablo değişir:
              Kasım&#8217;da ciro Ağustos&#8217;un <strong>3,8 katına</strong> çıktığı için bütçenin de o eğriyi izlemesi gerekir.
            </div>
          </div>

        </div>
      </div>
    </div>
  );
}
